import React, { useCallback } from 'react';

import { UpdateMaterialsSetCacheAction } from '../../../../../../materialsSets/materialsSetsTypes';
import { ClassName } from '../../../../../../../types';
import { SelectedMaterialsSidebarPopoverClearButtonMaterialsSet } from './SelectedMaterialsSidebarPopoverClearButton.types';

import { useEmptyMaterialsSet } from '../../../../../../materialsSets/hooks/useEmptyMaterialsSet';

import { useToastNotification } from '../../../../../../../common/hooks/useToastNotification';

import { PureButtonHelper } from '../../../../../../../helpers/buttons/PureButtonHelper';

import { parseRequestError } from '../../../../../../../utils/parseRequestError';

import { words } from '../../../../../../../locales/keys';

import { MaterialsSetCache } from '../../../../../../materialsSets/MaterialsSetCache';

interface SelectedMaterialsSidebarPopoverClearButtonProps {
  materialsSet: SelectedMaterialsSidebarPopoverClearButtonMaterialsSet;
  onClose: () => void;
  updateMaterialsSetCache: UpdateMaterialsSetCacheAction<SelectedMaterialsSidebarPopoverClearButtonMaterialsSet>;
  className?: ClassName;
}

function SelectedMaterialsSidebarPopoverClearButton({
  materialsSet,
  onClose,
  updateMaterialsSetCache,
  className
}: SelectedMaterialsSidebarPopoverClearButtonProps) {
  const uuid = materialsSet?.uuid;

  const { emptyMaterialsSetLoading, emptyMaterialsSet } = useEmptyMaterialsSet({
    itemCacheKey: MaterialsSetCache.showCacheKey(),
    updateMaterialsSetCache
  });

  const { showToastNotification } = useToastNotification({
    appearance: 'error'
  });

  const handleEmptyMaterialsSet = useCallback(() => {
    uuid &&
      emptyMaterialsSet({ uuid }).catch((error) => {
        showToastNotification(parseRequestError(error));
      });
    onClose();
  }, [uuid, emptyMaterialsSet, onClose, showToastNotification]);

  return (
    <PureButtonHelper
      className={
        className ||
        'font-medium hover:bg-gray-200 items-center px-4 py-2 rounded-md text-gray-700 text-sm dark:hover:bg-gray-700 dark:text-gray-300 focus:ring-offset-0'
      }
      dataGa="selected-materials-set-clear-button"
      i18nText={words.clearSelection}
      disabled={emptyMaterialsSetLoading}
      onClick={handleEmptyMaterialsSet}
    />
  );
}

export default SelectedMaterialsSidebarPopoverClearButton;
